import {gsap, ScrollTrigger, DrawSVGPlugin, MotionPathPlugin} from "gsap/all";

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, MotionPathPlugin);
gsap.config({nullTargetWarn: false});
gsap.defaults({ease: "none"});

class HeroAnimations {
    static init(id) {
        if (document.getElementById(id) === null) return;

        this.mainAnimations();
    }

    static mainAnimations() {
        let mm = gsap.matchMedia();


        mm.add("(min-width: 768px)", () => {
            // Desktop Animations
            const mainPath = gsap.timeline();
            const pulseCircle = gsap.timeline({
                repeat: -1,
                repeatDelay: 3,
                paused: true,
            });


            pulseCircle
                .from(".pulse-circle-first.top", {
                    scale: 0.6,
                    transformOrigin: 'center',
                    duration: 1,
                }, 0)
                .fromTo(".pulse-circle-first.bottom", {
                    scale: 0.6,
                    transformOrigin: 'center',
                    opacity: 1,
                }, {
                    scale: 1.8,
                    transformOrigin: 'center',
                    opacity: 0,
                    duration: 1,
                }, '-=1');

            pulseCircle.play();


            mainPath
                .fromTo('.sub-title-animate', {
                    opacity: '100%', duration: 0.1
                }, {opacity: '20%'},0)
                .fromTo('.main-title-animate', {
                    opacity: '20%', duration: 0.1
                }, {opacity: '100%'},0)
                .to('.dots > circle', {fill: '#FF7772', duration: 1}, 0)
                .to('.dots > circle', {opacity: 0, duration: 1}, '-=0.9')
                .to('#dot-1', {
                    motionPath: {
                        path: '#path-1',
                        align: '#path-1',
                        alignOrigin: [0.5, 0.5],
                    }, duration: 1
                }, 0)
                .to('#dot-2', {
                    motionPath: {
                        path: '#path-2',
                        align: '#path-2',
                        alignOrigin: [0.5, 0.5],
                    }, duration: 1
                }, 0)
                .to('#dot-3', {
                    motionPath: {
                        path: '#path-3',
                        align: '#path-3',
                        alignOrigin: [0.5, 0.5],
                    }, duration: 1
                }, 0)
                .to('#dot-4', {
                    motionPath: {
                        path: '#path-4',
                        align: '#path-4',
                        alignOrigin: [0.5, 0.5],
                    }, duration: 1
                }, 0)
                .to('#dot-5', {
                    motionPath: {
                        path: '#path-5',
                        align: '#path-5',
                        alignOrigin: [0.5, 0.5],
                    }, duration: 1
                }, 0)
                .from('#path1', {drawSVG: 0, duration: 9}, 1)
                .to('.pulse-circle-first', {
                    motionPath: {
                        path: '#path1',
                        align: '#path1',
                        alignOrigin: [0.5, 0.5],
                    }, duration: 9
                }, 1)
                .from('#path2', {drawSVG: 0, duration: 5})
                .to('.pulse-circle-first', {
                    motionPath: {
                        path: '#path2ForCircle',
                        align: '#path2ForCircle',
                        alignOrigin: [0.5, 0.5],
                    }, duration: 5
                }, '-=5')
                .fromTo('#path3', {drawSVG: 0}, {drawSVG: '100%', duration: 3})
                .to('.pulse-circle-first', {
                    motionPath: {
                        path: '#path3',
                        align: '#path3',
                        alignOrigin: [0.5, 0.5],
                    }, duration: 3
                }, '-=3')
                .from('#endPath', {drawSVG: 0, duration: 0.5})
                .to('.pulse-circle-first', {
                    motionPath: {
                        path: '#endPath',
                        align: '#endPath',
                        alignOrigin: [0.5, 0.5],
                    }, duration: 0.5
                }, '-=0.5')
                .to('.pulse-circle-first', {scale: 0, transformOrigin: 'center', duration: 0.1})
                .fromTo('#eye .gray-fill', {scaleY: 0.5, transformOrigin: 'center', opacity: 0}, {
                    scaleY: 1,
                    transformOrigin: 'center',
                    opacity: 1,
                    duration: 0.3
                }, '-=0.1')
                .fromTo('#eye .circle', {scale: 0.5, transformOrigin: 'center', opacity: 0}, {
                    scale: 1,
                    transformOrigin: 'center',
                    opacity: 1,
                    duration: 0.3
                }, '-=0.2')
                .fromTo('.ray', {opacity: 0}, {opacity: 1, duration: 0.3}, '-=0.2')

            ScrollTrigger.create({
                trigger: "#hero-animations",
                start: "top -50px",
                end: "90% 90%",
                animation: mainPath,
                scrub: 1,
            });

            ScrollTrigger.create({
                trigger: "#hero-animations",
                start: "top -50px",
                end: "90% bottom",
                onLeave: () => {
                    pulseCircle.pause(false);
                    gsap.set('.pulse-circle-first', {scale: 1, transformOrigin: 'center'});
                },
                onEnterBack: () => {
                    pulseCircle.play();
                },
            });

            const ray = document.querySelector('.ray');
            const rayBoundingBox = ray.getBoundingClientRect();

            document.addEventListener('mousemove', (event) => {
                const mouseX = event.clientX;

                const dx = rayBoundingBox.left + rayBoundingBox.width / 2 - mouseX;
                let angle = (dx / window.innerWidth) * 120;

                gsap.to(ray, {
                    duration: 0.5,
                    rotation: angle,
                    transformOrigin: 'top center',
                    ease: 'power2.out'
                });
            });

        });

        mm.add("(max-width: 767px)", () => {
            // Mobile Animations
            const mainPathMobile = gsap.timeline();
            const mainTitleMobile = gsap.timeline();
            const pulseCircleMobile = gsap.timeline({
                repeat: -1,
                repeatDelay: 3,
                paused: true,
            });


            pulseCircleMobile
                .from(".pulse-circle-first-mobile.top", {
                    scale: 0.6,
                    transformOrigin: 'center',
                    duration: 1,
                }, 0)
                .fromTo(".pulse-circle-first-mobile.bottom", {
                    scale: 0.6,
                    transformOrigin: 'center',
                    opacity: 1,
                }, {
                    scale: 1.8,
                    transformOrigin: 'center',
                    opacity: 0,
                    duration: 1,
                }, '-=1');

            pulseCircleMobile.play();

            mainPathMobile
                .to('.pulse-circle-first-mobile', {
                    motionPath: {
                        path: '#path1-mobile',
                        align: '#path1-mobile',
                        alignOrigin: [0.5, 0.5],
                    }, duration: 9
                }, 0)
                .from('#pathMobile1', {drawSVG: 0, duration: 0.5}, '-=9')
                .from('#pathMobile2', {drawSVG: 0, duration: 4.7}, '-=8.4')
                .from('#pathMobile3', {drawSVG: 0, duration: 6.3}, '-=3.7');

            mainTitleMobile .fromTo('.sub-title-animate', {
                opacity: '100%', duration: 0.1
            }, {opacity: '20%'},0)
                .fromTo('.main-title-animate', {
                    opacity: '20%', duration: 0.1
                }, {opacity: '100%'},0);

            ScrollTrigger.create({
                trigger: "#hero-animations",
                start: "150px top",
                end: "90% 90%",
                animation: mainPathMobile,
                scrub: 1,
            });

            ScrollTrigger.create({
                trigger: "#hero-animations",
                start: "50px top",
                end: "100px",
                animation: mainTitleMobile,
                scrub: 1,
            });
        });
    }
}


export default HeroAnimations;